/* eslint-disable react/jsx-props-no-spreading, max-len */
import Icon from '../components/Icon'
import cn from '../modules/cn'
import categories from './categories'

export default function LoadingIndicator({ className, ...props }) {
  return (
    <Icon className={cn('animate-spin', className)} {...props}>
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
      <path
        className="opacity-75"
        fill="currentColor"
        // eslint-disable-next-line max-len
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </Icon>
  )
}

LoadingIndicator.tags = ['Loading']
LoadingIndicator.category = categories.actions

LoadingIndicator.propTypes = {
  className: cn.propType,
}

LoadingIndicator.defaultProps = {
  className: null,
}
